(function() {
    angular
        .module('emarket.commons')
        .factory('CustomFields', ['$log', '$http', 'PATH', function($log, $http, PATH) {
            var path = PATH.api + '/custom-field';
            return {
                getByParentValue: function(parentId, value) {
                    var url = path + '/' + parentId + '/' + value;
                    return $http.get(url).then(function(response) {
                        return response.data;
                    });
                }
            };
        }]);
}());
